// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__wstah","pageTitle":"styles_pageTitle__lLqjf"};